
import { Component, Vue } from 'vue-property-decorator';
import { mainStore, extratoBancarioStore, userToolStore } from '@/store';
import ListTitulos from './ListTitulos.vue';
import ListExtratoBancario from './ListExtratoBancario.vue';
import DateComponent from '@/components/DateComponent.vue';
import ShowPopup from '@/components/ShowPopup.vue';

@Component({
  components: {
    DateComponent,
    ShowPopup,
    ListTitulos,
    ListExtratoBancario,
  },
})
export default class ExtratoBancario extends Vue {
  public titulos = [];
  public download_url = '';

  public headersTitulos = [
    {
      text: 'Data de Pagamento',
      sortable: true,
      value: 'data_pagamento',
      align: 'center',
    },
    {
      text: 'Filial',
      sortable: false,
      value: 'codigo_filial',
      align: 'center',
    },
    {
      text: 'Observação',
      sortable: false,
      value: 'observacao',
      align: 'center',
    },
    {
      text: 'Número Documento',
      sortable: false,
      value: 'numero_documento',
      align: 'center',
    },
    {
      text: 'Valor',
      sortable: true,
      value: 'valor_pago_liquido',
      align: 'center',
    },
    {
      text: 'Tipo',
      sortable: false,
      value: 'tipo',
      align: 'center',
    },
  ];

  //Filtros
  public filial = '';
  public formaBaixa = '';
  public dataInicialRecebimento = '';
  public dataFinalRecebimento = '';
  public tipo = '';
  public ano = new Date().getFullYear();

  public isLoading: boolean = false;

  get optionsFilial() {
    return ['1000', '1500', '2000', '3000', '4000'];
  }

  get optionsFormaBaixa() {
    return ['Todas', '1-RECEBIMENTO - BANCO', 'Recebido com Cartao', 'Recebimento PIX'];
  }

  get optionsTipo() {
    return ['Todos', 'Renegociação', 'Livro', 'Taxa de franquia', 'Mútuo', 'Permuta', 'Convenção', 'Diversos'];
  }

  get currentUserTool() {
    return (
      _.find(userToolStore.currentUserTools, {
        tool_id: 99,
      }) || {
        allow_view: false,
        allow_edit: false,
        allow_delete: false,
        allow_create: false,
      }
    );
  }

  get currentUser() {
    return mainStore.userProfile;
  }

  getFirstAndLastDayOfPreviousMonth() {
    const now = new Date();

    const previousMonth = new Date(now.getFullYear(), now.getMonth() - 1, 1);

    const firstDay = new Date(previousMonth.getFullYear(), previousMonth.getMonth(), 1);
    const firstDayFormatted = firstDay.toISOString().split('T')[0];

    const lastDay = new Date(previousMonth.getFullYear(), previousMonth.getMonth() + 1, 0);
    const lastDayFormatted = lastDay.toISOString().split('T')[0];

    return {
      firstDay: firstDayFormatted,
      lastDay: lastDayFormatted,
    };
  }

  public async gerar_relatorio() {
    let contas = [];

    const payload = {
      filial: this.filial,
      forma_baixa: this.formaBaixa,
      data_inicial: this.dataInicialRecebimento,
      data_final: this.dataFinalRecebimento,
      tipo: this.tipo,
    };
    this.download_url = await extratoBancarioStore.getExtratoBancarioRD(payload);
    let mywindow = window.open('_blank', 'scrollbars=yes, resizable=no, height=600,width=700,top=100,left=150');

    //@ts-ignore
    mywindow.document.write(this.download_url);
    //@ts-ignore
    mywindow.document.close(); // necessary for IE >= 10
    //@ts-ignore
    mywindow.focus(); // necessary for IE >= 10*/
  }

  get total() {
    let total = 0;
    this.titulos.forEach((element) => {
      total += element.valor_pago_liquido;
    });
    return total;
  }

  async getItems() {
    this.isLoading = true;
    const payload = {
      filial: this.filial,
      forma_baixa: this.formaBaixa,
      data_inicial: this.dataInicialRecebimento,
      data_final: this.dataFinalRecebimento,
      tipo: this.tipo,
    };
    this.titulos = await extratoBancarioStore.getTitulosRecebidos(payload);
    this.isLoading = false;
  }

  public async mounted() {
    this.isLoading = true;
    this.filial = '1000';
    this.formaBaixa = 'Todas';
    const previousMonthDays = this.getFirstAndLastDayOfPreviousMonth();
    this.dataInicialRecebimento = previousMonthDays.firstDay;
    this.dataFinalRecebimento = previousMonthDays.lastDay;
    this.tipo = 'Todos';

    const payload = {
      filial: this.filial,
      forma_baixa: this.formaBaixa,
      data_inicial: this.dataInicialRecebimento,
      data_final: this.dataFinalRecebimento,
      tipo: this.tipo,
    };
    this.titulos = await extratoBancarioStore.getTitulosRecebidos(payload);
    this.isLoading = false;
  }
}
